import  { componentAttributeTypes, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { FindClosestFixedHeightContainer, FixedHeightWarning } from "./FixedHeightWarning";

export default class BusinessClass extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessClass;
        this.displayName = "Classes";
        this.dropList = defaultDropList;
        this.editList = ["classFilter",componentAttributeTypes.filters,componentAttributeTypes.multiLocation, componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId,attributeTypes.width];
        this.resizeType = ResizeableType.HorizontalOnly;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation,"classFilter"];
        this.contentEditable = false;
        this.vagaroLink = "https://www.vagaro.com/merchants/settings/thingswesell/service";
        this.hideAdvancedSettings = true;
        this.icon =<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512" fill="currentColor" ><path d="M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"/></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("classFilter","Class Filter","",AttributeInputType.ClassCategorySelector)
        ];
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("v-review-percentage  w-full max-100 vb-control", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        const filters = getNodeComponentAttributeValue(component, componentAttributeTypes.filters, "");
        let inFixedString = "";
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="classes" layout={layout} classNames={atts.className} />
        }
        else{
            let fhnode = FindClosestFixedHeightContainer(component);
            if(fhnode){
                inFixedString = fhnode.typename;
            }
        }
        return (
            <Fragment>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                   {inFixedString &&<FixedHeightWarning node={component} typename={inFixedString}/>}
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="classes" node={component} userContext={siteData} filters={filters} rootId={(isEditor)?"a":"b"} />
                </div>
            </Fragment>
        )
    }
}
